import React from 'react';
import AddHostnameResourceContainer from './AddHostnameResourceContainer';
import AddIpResourceContainer from './AddIpResourceContainer';

const ResourceSelector = ({ tab, resourceState, addResource, clearResources, deleteResource }) => {
    return (
        <>
            {tab === 1 && (
                <AddHostnameResourceContainer
                    resourceState={resourceState}
                    onAddResource={(hostname) => addResource('selectedHostnames', hostname)}
                    onClear={() => clearResources('selectedHostnames')}
                    onDeleteResource={(hostname) => deleteResource('selectedHostnames', hostname)}
                />
            )}
            {tab === 2 && (
                <AddIpResourceContainer
                    resourceState={resourceState}
                    onAddResource={(ip) => addResource('selectedIps', ip)}
                    onClear={() => clearResources('selectedIps')}
                    onDeleteResource={(ip) => deleteResource('selectedIps', ip)}
                />
            )}
        </>
    );
};

export default ResourceSelector;
